var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.loading } },
    [
      _vm.cancelPlanModal
        ? _c("CancelPlanModal", {
            on: {
              confirm: function ($event) {
                return _vm.unsubscribe(_vm.cancelPlanModal)
              },
              reject: function ($event) {
                _vm.cancelPlanModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.subscribePlanModal
        ? _c("CreatePlanModal", {
            attrs: {
              planPeriod: _vm.localPeriod,
              loading: _vm.loadingSubscribe,
            },
            on: {
              confirm: function ($event) {
                return _vm.subscribe(_vm.subscribePlanModal)
              },
              reject: function ($event) {
                _vm.subscribePlanModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.creditCardRequired
        ? _c("CreditCardNeeded", {
            on: {
              close: function ($event) {
                _vm.creditCardRequired = null
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showWarn
        ? _c(
            "DowngradeWarn",
            {
              on: {
                close: function ($event) {
                  _vm.showWarn = null
                },
                forward: _vm.forwardPage,
              },
            },
            [
              _vm.showWarn == "supsis"
                ? [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("billing.packageCanNotDownSupsis")) +
                        "\n        "
                    ),
                  ]
                : _vm.showWarn == "whatsapp"
                ? [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("billing.packageCanNotDownWp")) +
                        "\n        "
                    ),
                  ]
                : _vm.showWarn == "whatsapp-business"
                ? [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("billing.packageCanNotDownWPBussiness")) +
                        "\n        "
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.chatbotExtraPackageModal
        ? _c("ExtraPlanModal", {
            attrs: { period: _vm.period },
            on: {
              confirm: _vm.subscribeExtra,
              close: function ($event) {
                _vm.chatbotExtraPackageModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "billing-plans" }, [
        _c("div", { staticClass: "title" }, [
          _c("div", { staticClass: "title-plan" }, [
            _c(
              "div",
              { staticClass: "title-plan-icon" },
              [_c("DynamicSvg", { attrs: { name: _vm.getIconName() } })],
              1
            ),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.getTitle()) +
                  "\n                "
              ),
            ]),
          ]),
          _vm._v(" "),
          !_vm.isAppsumo()
            ? _c("div", { staticClass: "plan-select-options" }, [
                _c(
                  "div",
                  { staticClass: "plan-select-option" },
                  [
                    _c("PlanPeriods", {
                      model: {
                        value: _vm.localPeriod,
                        callback: function ($$v) {
                          _vm.localPeriod = $$v
                        },
                        expression: "localPeriod",
                      },
                    }),
                    _vm._v(" "),
                    _vm.COUNTABLE_PLAN_TYPES.includes(_vm.type)
                      ? _c(
                          "div",
                          [
                            _c("Counter", {
                              attrs: { type: _vm.type },
                              model: {
                                value: _vm.details[_vm.counter[_vm.type]],
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.details,
                                    _vm.counter[_vm.type],
                                    $$v
                                  )
                                },
                                expression: "details[counter[type]]",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isWizard &&
                    !_vm.trialInfo.trial &&
                    _vm.type === "chatbot" &&
                    _vm.currentPlan &&
                    _vm.currentPlan.enabled
                      ? _c("div", { staticClass: "plan-select-option" }, [
                          _vm.type === "chatbot"
                            ? _c(
                                "div",
                                {
                                  staticClass: "extra-package",
                                  on: {
                                    click: function ($event) {
                                      _vm.chatbotExtraPackageModal = true
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "material-icons" }, [
                                    _vm._v("cake"),
                                  ]),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("billing.extraPackage")) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "plan-drag" }, [
                  _vm.prevButton
                    ? _c(
                        "div",
                        {
                          staticClass: "plan-drag-basic",
                          on: { click: _vm.previousPlan },
                        },
                        [
                          _c("div", { staticClass: "material-icons" }, [
                            _vm._v("arrow_back"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.nextButton
                    ? _c(
                        "div",
                        {
                          staticClass: "plan-drag-basic",
                          on: { click: _vm.nextPlan },
                        },
                        [
                          _c("div", { staticClass: "material-icons" }, [
                            _vm._v("arrow_forward"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c(
            "div",
            { ref: "supsisPlans", staticClass: "supsis-plans" },
            [
              _vm.teamGroupPlan
                ? _c("Card", {
                    staticClass: "plan",
                    style: {
                      transform:
                        "translateX(-" + _vm.currentPlanIndex * 100 + "%)",
                    },
                    attrs: {
                      plan: _vm.teamGroupPlan,
                      "is-admin": _vm.isAdmin,
                      wizard: _vm.isWizard,
                      "is-group-plan": true,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.customerPlans, function (plan, index) {
                return _c("Card", {
                  key: plan._id,
                  staticClass: "plan",
                  style: {
                    transform:
                      "translateX(-" + _vm.currentPlanIndex * 100 + "%)",
                  },
                  attrs: {
                    plan: plan,
                    period: _vm.localPeriod,
                    details: _vm.details,
                    "appsumo-coupons": _vm.appsumoCoupons,
                    plans: _vm.allLocalPlans,
                    "current-plans": _vm.localCurrentPlans,
                    "is-admin": _vm.isAdmin,
                    wizard: _vm.isWizard,
                    "is-selected": _vm.isSelected(plan),
                  },
                  on: {
                    subscribe: _vm.onSubscribe,
                    unsubscribe: _vm.onUnSubscribe,
                  },
                })
              }),
            ],
            2
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }